import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const backOfficeApi = createApi({
    reducerPath: 'backOfficeApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedBackOfficeApi = backOfficeApi.injectEndpoints({
    endpoints: (builder) => ({
        backOfficeList: builder.mutation({
            query: (config) => ({
                url: '/backoffice/search',
                method: 'POST',
                body: config,
            }),
        }),
        backOfficeAdd: builder.mutation({
            query: (config) => ({
                url: '/backoffice/add',
                method: 'POST',
                body: config,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useBackOfficeAddMutation, useBackOfficeListMutation } =
    injectedBackOfficeApi;
export default backOfficeApi;
